import axios from "axios";

class Mail {
  sendMail(data) {
    return axios.post("/mail", data);
  }
}

export default new Mail();
